import { LockOutlined } from "@ant-design/icons";
import { Form, Input } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const Password = ({ label = null, enforceStrongPassword = false, ...rest }) => {
  const { t } = useTranslation();
  const lowercaseLetterRegex = new RegExp(/[a-z]/);
  const uppercaseLetterRegex = new RegExp(/[A-Z]/);
  const numberRegex = new RegExp(/[0-9]/);
  // From aws cognito docs:
  // https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
  const specialCharacterRegex = new RegExp(
    /[!@#$%^?&*().,><':;_~`"=+}{\-\][\\/|]/
  );

  const rules = [
    { required: true, message: t("auth:form.password.errors.empty") },
  ];

  const strongPasswordRules = [
    { required: true, message: t("auth:form.newPassword.errors.empty") },
    { min: 8, message: t("auth:form.newPassword.errors.min") },
    {
      pattern: lowercaseLetterRegex,
      message: t("auth:form.newPassword.errors.lowercaseLetter"),
    },
    {
      pattern: uppercaseLetterRegex,
      message: t("auth:form.newPassword.errors.uppercaseLetter"),
    },
    { pattern: numberRegex, message: t("auth:form.newPassword.errors.number") },
    {
      pattern: specialCharacterRegex,
      message: t("auth:form.newPassword.errors.specialCharacter"),
    },
  ];
  return (
    <Form.Item
      name="password"
      label={label}
      required
      rules={enforceStrongPassword ? strongPasswordRules : rules}
      {...rest}
    >
      <Input.Password
        name="password"
        data-testid="password"
        placeholder={label ?? t("auth:form.password.label")}
        prefix={<LockOutlined className="inputIcon" />}
      />
    </Form.Item>
  );
};

Password.propTypes = {
  label: PropTypes.string,
  enforceStrongPassword: PropTypes.bool,
};

export default Password;
